(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fr-clinicianchoice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('frontrow-clinician-choice')) {
    class FrontrowClinicianChoice extends HTMLElement {
      #initialized = false;

      connectedCallback() {
        if (document.getElementById('frontrow-badge') !== this) {
          this.remove();
          return;
        }

        if (this.#initialized) return;
        this.#initialized = true;
        this.dataset.frontrowInitialized = 'true';

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://app.thefrontrowhealth.com/api/widgets/script?presentation_type=quant&product_id=5949';
        this.append(script);
      }
    }

    customElements.define('frontrow-clinician-choice', FrontrowClinicianChoice);
  }
  } catch(e) { console.error(e); }
})();

})();
